import { styled } from '@mui/material/styles';

const TabTitleCard = styled('div', {
  shouldForwardProp: (prop) => !['fontSize', 'bgColor', 'titleSize'].includes(prop),
})`
    position: relative;
    height: ${(props) => (props.height ? props.height : '15rem')};
    width: ${(props) => (props.width ? props.width : '10rem')};
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    border-radius: 3px;
    overflow: hidden;

    &h1{
        margin: 0;
        margin-block-start: unset;
        margin-block-end: unset;
        margin-inline-end: unset;
        margin-inline-start: unset;
        padding-inline-start: unset;
        list-style-type: none;
        width: 100%
        font-size: ${(props) => (props.fontSize ? props.fontSize : '2rem')};
    }

    &::after{
        content: '';
        position: absolute;
        z-index: 1;
        top: 0;
        left: 0.75em;
        width: 0;
        height: 90%;
        background-color: ${(props) => (props.bgColor ? props.bgColor : 'lightblue')};
        transition all 0.15s ease-in;
    }

    ul{
        margin: 0 0 0 -2em;
        padding-bottom: 0.5em;
        list-style-type: none;
        width: auto;
    }

    li {
        border-top: 1px solid lightgray;
        transition: .15s ease-in;

        &:hover {
            border-right: 3px solid #2ca6f4;
            cursor: pointer;
        }
    }

    li:last-child{
        border-bottom: 1px solid lightgray;
    }

    a{
        display: flex;
        padding: 0.5em 1em 0.5em 1em;
        color: black;
        text-decoration: none;
        height: 100%;
        width: 100%;

        &.disabled{
            color: lightgrey;
        }
        &.loading{
            color: lightgrey;
            display: flex;
            justify-content: space-between;
            align-items: center;
            cursor: wait;

            .spinner-border{
                color: black;
            }
        }
    }
`;

const CardContent = styled('div')`
  height: 100%;
  width: 100%;
`;

const CardHeadingWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'headingHeight',
})`
  position: relative;
  top: 0;
  right: 0;
  height: ${(props) => (props.headingHeight ? props.headingHeight : '15%')};
  width: 100%;
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.12),
    0 1px 2px rgba(0, 0, 0, 0.24);
`;

const CardHeading = styled('h5', {
  shouldForwardProp: (prop) => !['headingBgColor', 'headingFontColor'].includes(prop),
})`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  line-height: 1;
  text-align: center;
  top: 0;
  right: 0;
  z-index: 2;
  color: ${(props) => (props.headingFontColor ? props.headingFontColor : 'black')};
  font-weight: ${(props) => (props.headingFontWeight ? props.headingFontWeight : 'normal')};
  &::before {
    position: absolute;
    content: '';
    height: 100%;
    width: 100%;
    top: 0;
    right: 0;
    z-index: -1;
    background-color: ${(props) => (props.headingBgColor ? props.headingBgColor : 'lightblue')};
  }
`;

const CardBody = styled('div', {
  shouldForwardProp: (prop) => !['bgColor', 'headingHeight'].includes(prop),
})`
  position: relative;
  overflow: auto;
  height: ${(props) => {
    if (props.height == 'auto') {
      return 'auto';
    }
    return props.headingHeight ? 'calc(100% - ' + props.headingHeight + ')' : '83%';
  }};
  width: 100%;
  padding: 1em 1.25em 1em 0;
  bottom: 0;
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.12),
    0 1px 2px rgba(0, 0, 0, 0.24);
  background-color: ${(props) => (props.bgColor ? props.bgColor : 'white')};
`;

function Card(props) {
  return (
    <>
      <TabTitleCard
        height={props.height}
        width={props.width}
        titleSize={props.titleSize}
        fontSize={props.fontSize}
        bgColor={props.headingBgColor}
      >
        <CardContent>
          <CardHeadingWrapper width={props.iconSize} headingHeight={props.headingHeight}>
            <CardHeading
              headingBgColor={props.headingBgColor}
              headingFontColor={props.headingFontColor}
            >
              {props.title}
            </CardHeading>
          </CardHeadingWrapper>
          <CardBody
            bgColor={props.bgColor}
            headingHeight={props.headingHeight}
            height={props.height}
          >
            {props.children}
          </CardBody>
        </CardContent>
      </TabTitleCard>
    </>
  );
}

export { Card };
